import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'
import { Location } from '@reach/router'
import Img from 'gatsby-image'


export default () => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        allContentfulGame(sort: { fields: [publishDate], order: DESC }) {
          edges {
            node {
              name
              publishDate(formatString: "MMMM Do, YYYY")
              slug
              color
            }
          }
        }
        allContentfulSite(filter: { contentful_id: { eq: "3U3xgdVQHCikAG4sQc2Mai" } }) {
          edges {
            node {
              logo {
                fixed(width: 250, height: 96) {
                width
                height
                base64
                src
                srcSet
                }
                file {
                  url
                }
              }
              headerImage {
                fixed(width: 1024, height: 84) {
                width
                height
                base64
                src
                srcSet
                }
                file {
                  url
                }
              }
              title
              subtitle
              twitter
              facebook
              youtube
              instagram
              discord
            }
          }
        }
      }
    `}
    render={data => (
      <NavBar data={data} />
    )}
  />
)

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuActive: false }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => {
      return {
        menuActive: !prevState.menuActive
      }
    })
  }

  render() {
    const { data } = this.props;
    const navWrapperClasses = "nav-wrap" + (this.state.menuActive ? " active" : "");

    return (
      <nav>
        <div className="container">
          <Link to="/" className="logo"><img alt="" src={data.allContentfulSite.edges[0].node.headerImage.file.url} /></Link>
          <div className="nav-mobile" onClick={this.handleClick}>
            <span className="fas fa-bars">&nbsp;</span>
            <img src={data.allContentfulSite.edges[0].node.logo.file.url}/>
          </div>
          <div className={navWrapperClasses}>
            <ul className="nav-left">
              <li className="mobile-li mobile-show"><Link to="/">Home</Link></li>
              {data.allContentfulGame.edges.map(({ node }) => {
                return (
                  <li className="mobile-li" key={node.slug}>
                    <Link to={`/games/${node.slug}`} activeClassName="active" className="game" style={{ color: node.color }}>{node.name}</Link>
                  </li>
                )
              })}
              <li className="mobile-li"><Link to="/blog/"><img src="/icon_news.png" /> News</Link></li>
              <li className="mobile-li"><Link to="/join/"><img src="/icon_join.png" /> Join</Link></li>
              <li className="mobile-li"><Link to="/team/"><img src="/icon_about.png" /> About</Link></li>
              <li className="mobile-li"><Link to="/contact/"><img src="/icon_contact.png" /> Contact</Link></li>
              <li className="mobile-li"><a href="https://supergiant.games/merch"><img src="/icon_merch.png" /> <b>Merch</b></a></li>
            </ul>
            <ul className="nav-right">
              <li className="social"><a href={`http://www.twitter.com/${data.allContentfulSite.edges[0].node.twitter}`} className="fab cus-twitter first"><img class="social-icons" src="/x.png" /></a></li>
              <li className="social"><a href={`http://www.facebook.com/${data.allContentfulSite.edges[0].node.facebook}`} className="fab fa-facebook"></a></li>
              <li className="social"><a href={`http://www.youtube.com/user/${data.allContentfulSite.edges[0].node.youtube}`} className="fab fa-youtube last"></a></li>
              <li className="social"><a href={`http://www.instagram.com/${data.allContentfulSite.edges[0].node.instagram}`} className="fab fa-instagram last"></a></li>
              <li className="social"><a href={`https://discord.gg/${data.allContentfulSite.edges[0].node.discord}`} className="fab fa-discord last"></a></li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}
